import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CiNotification } from 'src/app/models/ci-notification';
import { BellNotificationService } from 'src/app/services/bell-notification.service';
import { UrlHelper } from 'src/app/helpers/urlHelper';

@Component({
  selector: 'app-notification-block',
  templateUrl: './notification-block.component.html',
  styleUrls: ['./notification-block.component.scss'],
  animations: [
    trigger('slideNotification', [
      transition(':enter', [
        style({ height: '0px' }),
        animate('100ms ease-out')
      ]),
      transition(':leave', [
        animate('200ms ease-out', style({ height: '0px' }))
      ]),
      state('*', style({ height: '*' })),
    ])
  ]
})
export class NotificationBlockComponent implements OnInit {

  @Input() notification: CiNotification;
  @Input() internalApp: boolean = false;

  expanded: boolean = false;

  showGoUrl: boolean = false;

  constructor(
    private notificationService: BellNotificationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.showGoUrl = this.notificationService.isSetUrlGoNotification();
  }

  hideNotification() {
    this.notificationService.sendNotificationSeen(this.notification.id)
    .subscribe(() => {
      this.notificationService.setReloadNotifiactions();
    });
  }

  goNotification() {
    const url = this.notificationService.urlGoNotification(this.notification.module);
    if(UrlHelper.isExternalUrl(url)) {
      window.location.href = url;
    } else {
      this.router.navigateByUrl('/',{skipLocationChange: true}).then(() => {
        this.router.navigate([url]);
      });
    }
  }
}
